// Which content this build offers (ROADMAP D30). Every built bundle — the live site, and wrangler dev, which serves
// the same build — offers released modes only and shows preview modes as coming-soon teasers; the development server
// (`npm run dev`) plays previews too, so they can be worked on.

import { GAME_MODES, type GameModeKey } from '@taxwar/content'

const PREVIEWS_PLAYABLE: boolean = import.meta.env.DEV

export function isModePlayable(mode: GameModeKey): boolean {
  return GAME_MODES[mode].release === 'released' || PREVIEWS_PLAYABLE
}
